import { CountUp } from 'countup.js';

window.handleCountUp = ()->
  $('.count-up:not(.completed)').each ()->
    node = $(this)
    target = node.data('target')
    decimal = node.data('decimal') || 0
    node.addClass('completed')
    new CountUp(node[0], target, decimalPlaces: decimal).start()